import { render, staticRenderFns } from "./message-footer.vue?vue&type=template&id=5c346f94&scoped=true&"
import script from "./message-footer.vue?vue&type=script&lang=js&"
export * from "./message-footer.vue?vue&type=script&lang=js&"
import style0 from "./message-footer.vue?vue&type=style&index=0&id=5c346f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c346f94",
  null
  
)

export default component.exports